const config = {
  ///baseURL: "http://localhost:8082/api",
  baseURL: "https://nouvelle-tarification-ms.portnet.ma/api",
  //baseURL: "https://nouvelle-tarificationdev.portnet.ma/api",
  //referentielBaseURL: "https://referentiel-api-v2.portnet.ma/",
   referentielBaseURL: "https://referentiel-api-prod-v2.portnet.ma/",
  // referentielBaseURL: "http://localhost:8082/",
};
export default config;
